import { initBotId } from 'botid/client/core'

import { advisorBotIdOptions, advisorBotIdRoute } from './advisor-config'
import { connectFormTokenBotIdRoute } from './connect-config'

initBotId({
  protect: [
    { path: '/api/hearing-aids/guide-eligibility', method: 'POST', ...advisorBotIdOptions },
    advisorBotIdRoute,
    connectFormTokenBotIdRoute,
  ],
})
